const deTranslation = require('./de.json')
const deSurveyTranslation = require('./deSurveys.json')

const newTranslation = { ...deSurveyTranslation, ...deTranslation }

export default newTranslation
